export const ENV = {
  LOCAL: 'local',
  STAGING: 'staging',
  PRODUCTION: 'production'
};
export const BASIC_TENANT = 'dental';

export const LOCAL_DEFAULT_PAGE = 'http://localhost:4200';
export const LOCAL_SHARED_LINK = 'localhost:4202';

// Local environment
export const LOCAL_BASE_URL = 'http://localhost:8013';
export const LOCAL_API_URL = `http://${BASIC_TENANT}.localhost:8013/api/dental`;
export const LOCAL_API_URL_V2 = `http://${BASIC_TENANT}.localhost:8013/api`;
export const LOCAL_ECHO_CONFIG_AUTH_ENDPOINT = `http://${BASIC_TENANT}.localhost:8013/api/broadcasting/auth`;

// Staging environment
export const STAGING_DEFAULT_PAGE = 'https://staging.mymedsph.app';

export const STAGING_BASE_URL = 'https://staging.api.mymedsph.app';
export const STAGING_API_URL = `https://staging.api.mymedsph.app/api/dental`;
export const STAGING_API_URL_V2 = `https://staging.api.mymedsph.app/api`;
export const STAGING_ECHO_CONFIG_AUTH_ENDPOINT = `https://staging.api.mymedsph.app/api/broadcasting/auth`;
export const STAGING_SPLIT_AUTHORIZATION_KEY = 'jkj9a66rgnl2lsagsgv3qqcbrk77famookuq';

// Production environment base URLs
export const PROD_DEFAULT_PAGE = 'https://dental.mymedsph.app';
export const PROD_BASE_URL = 'mymedsph.app';
export const PROD_API_BASE_URL = 'api.mymedsph.app';

export const SHARED_LINK = 'm.mymedsph.app';
export const PROD_SPLIT_AUTHORIZATION_KEY = 'siointboc09e60tlvsiajpj1sfh5fvqirvbn';

export const STAGING_TENANT = new Set([
    'hanadent',
    'aldent',
    'jomsdent',
    'julsdent',
  ]);
